import Component from '../Component';
export default class ClipComponent extends Component {
}
